import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

export const GetDefaultTenant: any = createAsyncThunk<any>(
	'GetDefaultTenant',
	async () => {
		const response = await httpService.get(
			`system-portal/get-tenant-defaults`
		);
		return response.data.data;
	}
);

export const GetTenantDetails: any = createAsyncThunk<any>(
	'GetTenantDetails',
	async (data: any) => {
		const response = await httpService.get(`system-portal/tenant`, {
			params: {
				tenantId: data
			}
		});
		return response.data.data;
	}
);
export const CreateTenantDetails: any = createAsyncThunk<any>(
	'CreateTenantDetails',
	async (data: any, { rejectWithValue }: any) => {
		// eslint-disable-next-line no-useless-catch
		try {
			const response = await httpService.post(
				`system-portal/tenant`,
				data
			);
			return response;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
// export const UpdateTenantDetails: any = createAsyncThunk<any>(
//   "UpdateTenantDetails",
//   async (data: any) => {
//     const response = await httpService.put(`system-portal/tenant?tenantId=${data.id}`, data.data);
//     return response.data.data;
//   }
// );
export const UpdateTenantDetails: any = createAsyncThunk<any>(
	'UpdateTenantDetails',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`system-portal/tenant?tenantId=${data.id}`,
				data.data
			);
			return response.data.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const getTenantList: any = createAsyncThunk<any>(
	'getTenantList',
	async (data: any) => {
		const response = await httpService.get(`system-portal/get-tenants`, {
			params: data
		});
		return response.data.data;
	}
);
export const getBranched: any = createAsyncThunk<any>(
	'getBranched',
	async () => {
		const response = await httpService.get(`system-portal/get-tenants`);
		return response.data.data;
	}
);
export const createBranched: any = createAsyncThunk<any>(
	'createBranched',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.post(
				`system-portal/tenant-branch`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const updateBranched: any = createAsyncThunk<any>(
	'updateBranched',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`system-portal/tenant-branch`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const deleteBranched: any = createAsyncThunk<any>(
	'deleteBranched',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.delete(
				`system-portal/tenant-branch`,
				{ params: data }
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const getSearchTenantList: any = createAsyncThunk<any>(
	'getSearchTenantList',
	async (data: any) => {
		const response = await httpService.get(`system-portal/search-tenant`, {
			params: data
		});
		return response.data.data;
	}
);
export const linkedTenants: any = createAsyncThunk<any>(
	'linkedTenants',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`system-portal/linked-tenants`,
				data
			);
			return response.data.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);

export const otherLinikedTenants: any = createAsyncThunk<any>(
	'otherLinikedTenants',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.get(
				`tenant-portal/eachOtherLinkedTenants`,
				{ params: data }
			);
			return response.data.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const removeLinkedTenant: any = createAsyncThunk<any>(
	'removeLinkedTenant',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.delete(
				`system-portal/linked-tenants`,
				{ params: data }
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const deleteTenant: any = createAsyncThunk<any>(
	'deleteTenant',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.delete(`system-portal/tenant`, {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const resetTenantPassword: any = createAsyncThunk<any>(
	'resetTenantPassword',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await httpService.put(
				`system-portal/change-tenant-owner-password`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const allowNewItems: any = createAsyncThunk<any>(
	'allowNewItems',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/tenant-portal/allowNewValidation',
				{ params: data }
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const allowNewProducts: any = createAsyncThunk<any>(
	'allowNewProducts',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/product/allowNewValidation',
				{ params: data }
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const GetTenantServices: any = createAsyncThunk<any>(
	'GetTenantServices',
	async (data: any) => {
		const response = await httpService.get(
			`system-portal/tenant`,
			{ params: data }
		);
		return response.data.data;
	}
);